// Studyo Today GoogleCalendar
// Package studyo.today.google_calendar.v1
// Service definitions
// Copyright (c) 2015-2020 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/google_calendar/v1/google_calendar.proto (package studyo.today.google_calendar.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_google_calendar_v1_resources_calendar } from "./resources/calendar_pb.js";
import { file_studyo_today_google_calendar_v1_resources_sync_status } from "./resources/sync_status_pb.js";
import { file_studyo_today_type_client_app_kind } from "@buf/studyo_studyo-today-common.bufbuild_es/studyo/today/type/client_app_kind_pb.js";

/**
 * Describes the file studyo/today/google_calendar/v1/google_calendar.proto.
 */
export const file_studyo_today_google_calendar_v1_google_calendar = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvZ29vZ2xlX2NhbGVuZGFyL3YxL2dvb2dsZV9jYWxlbmRhci5wcm90bxIfc3R1ZHlvLnRvZGF5Lmdvb2dsZV9jYWxlbmRhci52MSJ/CiBSZWdpc3Rlck9mZmxpbmVBY2Nlc3NDb2RlUmVxdWVzdBIMCgRjb2RlGAEgASgJEjkKD2NsaWVudF9hcHBfa2luZBgCIAEoDjIgLnN0dWR5by50b2RheS50eXBlLkNsaWVudEFwcEtpbmQSEgoKcGxhbm5lcl9pZBgDIAEoCSI0Ch5SZXZva2VPZmZsaW5lQWNjZXNzQ29kZVJlcXVlc3QSEgoKcGxhbm5lcl9pZBgBIAEoCSIqChRHZXRTeW5jU3RhdHVzUmVxdWVzdBISCgpwbGFubmVyX2lkGAEgASgJIigKElN5bmNocm9uaXplUmVxdWVzdBISCgpwbGFubmVyX2lkGAEgASgJIikKE0dldENhbGVuZGFyc1JlcXVlc3QSEgoKcGxhbm5lcl9pZBgBIAEoCSJeChRHZXRDYWxlbmRhcnNSZXNwb25zZRJGCgljYWxlbmRhcnMYASADKAsyMy5zdHVkeW8udG9kYXkuZ29vZ2xlX2NhbGVuZGFyLnYxLnJlc291cmNlcy5DYWxlbmRhciJTCh5VcGRhdGVDYWxlbmRhclNlbGVjdGlvblJlcXVlc3QSEgoKcGxhbm5lcl9pZBgBIAEoCRIdChVzZWxlY3RlZF9jYWxlbmRhcl9pZHMYAiADKAkiaQofVXBkYXRlQ2FsZW5kYXJTZWxlY3Rpb25SZXNwb25zZRJGCgljYWxlbmRhcnMYASADKAsyMy5zdHVkeW8udG9kYXkuZ29vZ2xlX2NhbGVuZGFyLnYxLnJlc291cmNlcy5DYWxlbmRhcjL/BQoOR29vZ2xlQ2FsZW5kYXISeAoZUmVnaXN0ZXJPZmZsaW5lQWNjZXNzQ29kZRJBLnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEuUmVnaXN0ZXJPZmZsaW5lQWNjZXNzQ29kZVJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiABJ0ChdSZXZva2VPZmZsaW5lQWNjZXNzQ29kZRI/LnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEuUmV2b2tlT2ZmbGluZUFjY2Vzc0NvZGVSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgASfwoNR2V0U3luY1N0YXR1cxI1LnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEuR2V0U3luY1N0YXR1c1JlcXVlc3QaNS5zdHVkeW8udG9kYXkuZ29vZ2xlX2NhbGVuZGFyLnYxLnJlc291cmNlcy5TeW5jU3RhdHVzIgASXAoLU3luY2hyb25pemUSMy5zdHVkeW8udG9kYXkuZ29vZ2xlX2NhbGVuZGFyLnYxLlN5bmNocm9uaXplUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIAEn0KDEdldENhbGVuZGFycxI0LnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEuR2V0Q2FsZW5kYXJzUmVxdWVzdBo1LnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEuR2V0Q2FsZW5kYXJzUmVzcG9uc2UiABKeAQoXVXBkYXRlQ2FsZW5kYXJTZWxlY3Rpb24SPy5zdHVkeW8udG9kYXkuZ29vZ2xlX2NhbGVuZGFyLnYxLlVwZGF0ZUNhbGVuZGFyU2VsZWN0aW9uUmVxdWVzdBpALnN0dWR5by50b2RheS5nb29nbGVfY2FsZW5kYXIudjEuVXBkYXRlQ2FsZW5kYXJTZWxlY3Rpb25SZXNwb25zZSIAQiaqAiNTdHVkeW8uVG9kYXkuR29vZ2xlQ2FsZW5kYXIuR3JwYy5WMWIGcHJvdG8z", [file_google_protobuf_empty, file_studyo_today_google_calendar_v1_resources_calendar, file_studyo_today_google_calendar_v1_resources_sync_status, file_studyo_today_type_client_app_kind]);

/**
 * Describes the message studyo.today.google_calendar.v1.RegisterOfflineAccessCodeRequest.
 * Use `create(RegisterOfflineAccessCodeRequestSchema)` to create a new message.
 */
export const RegisterOfflineAccessCodeRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 0);

/**
 * Describes the message studyo.today.google_calendar.v1.RevokeOfflineAccessCodeRequest.
 * Use `create(RevokeOfflineAccessCodeRequestSchema)` to create a new message.
 */
export const RevokeOfflineAccessCodeRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 1);

/**
 * Describes the message studyo.today.google_calendar.v1.GetSyncStatusRequest.
 * Use `create(GetSyncStatusRequestSchema)` to create a new message.
 */
export const GetSyncStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 2);

/**
 * Describes the message studyo.today.google_calendar.v1.SynchronizeRequest.
 * Use `create(SynchronizeRequestSchema)` to create a new message.
 */
export const SynchronizeRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 3);

/**
 * Describes the message studyo.today.google_calendar.v1.GetCalendarsRequest.
 * Use `create(GetCalendarsRequestSchema)` to create a new message.
 */
export const GetCalendarsRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 4);

/**
 * Describes the message studyo.today.google_calendar.v1.GetCalendarsResponse.
 * Use `create(GetCalendarsResponseSchema)` to create a new message.
 */
export const GetCalendarsResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 5);

/**
 * Describes the message studyo.today.google_calendar.v1.UpdateCalendarSelectionRequest.
 * Use `create(UpdateCalendarSelectionRequestSchema)` to create a new message.
 */
export const UpdateCalendarSelectionRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 6);

/**
 * Describes the message studyo.today.google_calendar.v1.UpdateCalendarSelectionResponse.
 * Use `create(UpdateCalendarSelectionResponseSchema)` to create a new message.
 */
export const UpdateCalendarSelectionResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_google_calendar, 7);

/**
 * Service definition for the Today Google Calendar API.
 *
 * @generated from service studyo.today.google_calendar.v1.GoogleCalendar
 */
export const GoogleCalendar = /*@__PURE__*/
  serviceDesc(file_studyo_today_google_calendar_v1_google_calendar, 0);

